module.exports = __webpack_public_path__ + "img/customerCare.a29050c1.svg";